import { useEffect } from 'react'
import { useProjectStageStore } from '@/components/common/menu/lib/store/useProjectStageStore.tsx'
import { useLoaderData } from 'react-router-dom'
import useNotificationsSubscriber from '@/routes/projectStages/notifications/lib/hooks/useNotificationsSubscriber.tsx'
import useCreateStageFilters from '@/routes/root/lib/hooks/useCreateStageFilters.tsx'
import { RootLoaderT } from '@/routes/root/lib/actions/rootLoader.ts'
import { currStageIssueTypesQuery } from '@/lib/actions/getStageIssuesTypes.ts'
import { useQuery } from '@tanstack/react-query'
import { currStageQuery } from '@/lib/actions/getCurrStage.ts'
import { editUser } from '@/routes/settings/account/actions.ts'

type PropsT = {
  path: 'Root' | 'ProjectStage'
  disabled?: boolean
}

const useProjectStageData = ({ disabled }: PropsT) => {
  // console.log({ path })
  const data = useLoaderData() as Awaited<RootLoaderT>

  const { stageId, stageUsers, stageIssueTypes, stage, userId } = data ?? {}

  const { data: stageIssueTypesQuery, error: stageIssueTypesError } = useQuery({
    ...currStageIssueTypesQuery(stageId as string),
    enabled: !!stageId,
    throwOnError: false,
  })

  const { data: stageQuery, error: stageQueryError } = useQuery({
    ...currStageQuery(stageId as string, userId as number),
    enabled: !!stageId,
    throwOnError: false,
  })

  useEffect(() => {
    if ((stageQueryError || stageIssueTypesError) && userId) {
      editUser(userId, { activeProjectStage: null }).catch(console.error)
    }
  }, [stageQueryError, stageIssueTypesError, userId])

  const setCurrProjectStage = useProjectStageStore(state => state.setCurrProjectStage)
  const setIssueTypes = useProjectStageStore(state => state.setIssueTypes)

  // Hydrate from loader once
  useEffect(() => {
    if (disabled) return
    if (stage) setCurrProjectStage(stage)
    if (stageIssueTypes) setIssueTypes(stageIssueTypes)
  }, [disabled, stage, stageIssueTypes, setCurrProjectStage, setIssueTypes])

  // Update from React Query whenever it changes
  useEffect(() => {
    if (disabled) return
    if (stageQuery) setCurrProjectStage(stageQuery)
    if (stageIssueTypesQuery) setIssueTypes(stageIssueTypesQuery)
  }, [disabled, stageQuery, stageIssueTypesQuery, setCurrProjectStage, setIssueTypes])

  // useUpdateStageTabHref()
  useNotificationsSubscriber(stageUsers, stageId)
  useCreateStageFilters(stageUsers, stageId)
}

export default useProjectStageData
